export const SYNTHESIS_CARD_WIDGET_ID = 'cc3b0f06-59e6-53dd-ada0-3ace12bc86ce';

// Card add/edit happens on the Synthesis credit-card widget (Stripe is being
// migrated to Synthesis) rather than in-platform. The widget is the same for
// every org; the numeric org id (Organization.synthesisOrgId) is passed as `orgid`.
export function synthesisCardWidgetUrl (orgId) {
  return `https://api.synthesisvr.com/widgets/${SYNTHESIS_CARD_WIDGET_ID}?orgid=${orgId}`;
}
